import type { ExcalidrawElement } from "@excalidraw/excalidraw/element/types";
import type { AppState, BinaryFiles } from "@excalidraw/excalidraw/types";

type ExportExcalidrawBlobParams = {
  elements: readonly ExcalidrawElement[];
  appState: Partial<AppState>;
  files: BinaryFiles;
  mimeType: string;
};

/** Lazy-load Excalidraw export (package touches `window` at module init). */
export async function exportExcalidrawBlob(params: ExportExcalidrawBlobParams): Promise<Blob> {
  const { exportToBlob } = await import("@excalidraw/excalidraw");
  return exportToBlob(params);
}
